import { Backdrop, Box, LinearProgress, Typography, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';

const ProgressLoader = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 200);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'rgba(0, 0, 0, 0.7)'
      }}
      open={true}
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        gap={3}
        sx={{
          width: { xs: '90%', sm: '400px', md: '500px' },
          padding: 3,
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          borderRadius: 2,
          backdropFilter: 'blur(10px)',
        }}
      >
        <Box
          component="img"
          src="https://inboxlogy-cdn.s3.amazonaws.com/logo-mark.png"
          alt="Loading..."
          sx={{
            width: { xs: '60px', sm: '70px', md: '80px' },
            height: 'auto',
            animation: 'gentlePulse 2s ease-in-out infinite',
            '@keyframes gentlePulse': {
              '0%, 100%': {
                transform: 'scale(1)',
                opacity: 1,
              },
              '50%': {
                transform: 'scale(1.05)',
                opacity: 0.9,
              },
            },
          }}
        />
        <CircularProgress
          variant="determinate"
          value={progress}
          size={80}
          thickness={4}
          sx={{
            color: '#fff',
            '& .MuiCircularProgress-circle': {
              strokeLinecap: 'round',
            },
          }}
        />
        <Box sx={{ width: '100%' }}>
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{
              height: 8,
              borderRadius: 4,
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              '& .MuiLinearProgress-bar': {
                borderRadius: 4,
                backgroundColor: '#fff',
              },
            }}
          />
        </Box>
        <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#fff' }}>
          {Math.round(progress)}%
        </Typography>
        <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
          Loading component...
        </Typography>
      </Box>
    </Backdrop>
  );
};

export default ProgressLoader;
